import React from "react";
import SuggestionHistory from "../../components/SuggestionHistory/SuggestionHistory";
import { useSuggestionSystem } from "./useSuggestionSystem";
import { bulan, tahun } from "../../util/constant";
import "./SuggestionSystem.css";

export default function SuggestionSystem() {
  const {
    user,
    handleBefore,
    handleAfter,
    handleUpload,
    imgBefore,
    imgAfter,
    idePerbaikan,
    setIdePerbaikan,
    tujuanPerbaikan,
    setTujuanPerbaikan,
    status,
    setStatus,
    subMenu,
    setSubMenu,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    handleKirimLeader,
    handleDelete,
    isDisabled,
    setIsDisabled,
    handleChangeKomentar,
    handleChangeChecklist,
    handleChangeQcdsm,
    subMenuRiwayat,
    handleChangeKategori,
    images,
  } = useSuggestionSystem();

  return (
    <div className="container_dashboard">
      <div className="wrapper_sub_menu_ss">
        <p
          className={
            subMenu === "Input" ? "sub_menu_ss border_active_ss" : "sub_menu_ss"
          }
          onClick={() => setSubMenu("Input")}
        >
          Input
        </p>
        <p
          className={
            subMenu === "Riwayat"
              ? "sub_menu_ss border_active_ss"
              : "sub_menu_ss"
          }
          onClick={() => setSubMenu("Riwayat")}
        >
          Riwayat
        </p>
      </div>

      <h2>Suggestion System</h2>

      {subMenu === "Input" ? (
        <>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <div style={{ flex: 1, minWidth: 300 }}>
              <p style={{ fontWeight: 600, margin: "0 0 12px 0" }}>
                Ide Perbaikan
              </p>
              <textarea
                value={idePerbaikan}
                onChange={(e) => setIdePerbaikan(e.target.value.toUpperCase())}
                style={{
                  width: "95%",
                  height: 70,
                  padding: 8,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                  outline: "none",
                  resize: "none",
                }}
              />
            </div>

            <div style={{ flex: 1, minWidth: 300 }}>
              <p style={{ fontWeight: 600, margin: "0 0 12px 0" }}>
                Tujuan Perbaikan
              </p>
              <textarea
                value={tujuanPerbaikan}
                onChange={(e) =>
                  setTujuanPerbaikan(e.target.value.toUpperCase())
                }
                style={{
                  width: "95%",
                  height: 70,
                  padding: 8,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                  outline: "none",
                  resize: "none",
                }}
              />
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <div style={{ flex: 1, minWidth: 250 }}>
              <p style={{ fontWeight: 600 }}>Before</p>
              <input
                key={imgBefore || "before"}
                type="file"
                accept="image/*"
                onChange={handleBefore}
              />
              {imgBefore && (
                <img
                  src={imgBefore}
                  alt="before preview"
                  style={{
                    width: "100%",
                    maxWidth: "250px",
                    marginTop: 8,
                    borderRadius: 8,
                  }}
                />
              )}
            </div>

            <div style={{ flex: 1, minWidth: 250 }}>
              <p style={{ fontWeight: 600 }}>After</p>
              <input
                key={imgAfter || "after"}
                type="file"
                onChange={handleAfter}
              />
              {imgAfter && (
                <img
                  src={imgAfter}
                  alt="after preview"
                  style={{
                    width: "100%",
                    maxWidth: "250px",
                    marginTop: 8,
                    borderRadius: 8,
                  }}
                />
              )}
            </div>

            <div style={{ flex: 1, minWidth: 200 }}>
              <p style={{ fontWeight: 600, marginBottom: "12px" }}>Status</p>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                style={{
                  width: "100%",
                  padding: 8,
                  borderRadius: 6,
                  border: "1px solid #ccc",
                }}
              >
                <option value="">Pilih</option>
                <option value="Belum">Belum Dilakukan</option>
                <option value="Sudah">Sudah Dilakukan</option>
              </select>
            </div>
          </div>
          <br />
          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <button
              disabled={isDisabled}
              onClick={() => {
                setIsDisabled(true);
                handleUpload();
              }}
              style={{
                padding: "10px 16px",
                background: "#1976d2",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                cursor: "pointer",
              }}
            >
              Upload
            </button>
          </div>
          <br />
        </>
      ) : subMenu === "Riwayat" ? (
        <div>
          <div style={{ display: "flex", gap: "16px" }}>
            <select
              className="select-filter-bulan-tahun"
              defaultValue="Bulan"
              onChange={(e) => setFilterBulan(e.target.value)}
              value={filterBulan}
            >
              <option selected disabled>
                Bulan
              </option>
              {bulan.map((ele) => (
                <option value={Number(ele.value)}>{ele.name}</option>
              ))}
            </select>
            <select
              className="select-filter-bulan-tahun"
              defaultValue="Tahun"
              onChange={(e) => setFilterTahun(e.target.value)}
              value={filterTahun}
            >
              <option selected disabled>
                Tahun
              </option>
              {tahun.map((ele) => (
                <option value={ele}>{ele}</option>
              ))}
            </select>
          </div>
          <br />
          <SuggestionHistory
            images={images}
            role={user}
            handleKirimLeader={handleKirimLeader}
            handleDelete={handleDelete}
            handleChangeKomentar={handleChangeKomentar}
            handleChangeChecklist={handleChangeChecklist}
            handleChangeQcdsm={handleChangeQcdsm}
            handleChangeKategori={handleChangeKategori}
            isGantiSubMenuRiwayat={subMenuRiwayat}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
